import { axiosContentDetail } from "../axios";
import { getContentWithLanguage } from "../util/language";
import { SERIES_PAGE_ACTIONS } from "./actionTypes";

const SeriesDetailUrl = "/api/v1/event/series";
const SeriesVodUrl = "/pub/api/v2/vod/event/series";
import { handleActionError } from "../util/error";

export const getSeriesDetailAction = ({ id, token, language }) => {
  return dispatch => {
    let reqBody = {
      "id": id,
      "token": token
    }
    return axiosContentDetail
      .post(`${SeriesDetailUrl}`, reqBody)
      .then(response => {
        const { data = {} } = response;
        const parsedLanguageData = getContentWithLanguage(data.data, language)
        dispatch({
          type: SERIES_PAGE_ACTIONS.SERIES_DETAIL._SUCCESS,
          payload: { data: parsedLanguageData }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while getting series-related VOD data:", error);
        dispatch({
          type: SERIES_PAGE_ACTIONS.SERIES_DETAIL._FAILURE
        });
      });
  };
};

export const getSeriesVods = ({ id, offset, max, token, language }) => {
  return dispatch => {
    let reqBody = {
      "id": id,
      "token": token,
      "offset": offset,
      "max": max
    }
    return axiosContentDetail
      .post(`${SeriesVodUrl}`, reqBody)
      .then(response => {
        const { data = {} } = response;
        const parsedLanguageData = getContentWithLanguage(data.data.contentResults, language)
        dispatch({
          type: SERIES_PAGE_ACTIONS.SERIES_VODS._SUCCESS,
          payload: { data: parsedLanguageData, offset }
        });
      })
      .catch(error => {
        handleActionError("An error occurred while attempting to retrieve series VODs:", error);
        dispatch({
          type: SERIES_PAGE_ACTIONS.SERIES_VODS._FAILURE
        });
      });
  };
};

